import { Injectable } from '@angular/core';
import { TabTemplateCacheService } from './tab-template-cache.service';

@Injectable({
  providedIn: 'root'
})
export class TabTemplateNameGeneratorService {

  constructor(
    private templateCacheService: TabTemplateCacheService,
  ) {}

  generateNewTemplateName(rootTemplateName): string {
    const cachedTemplates = this.getCachedTemplates();

    const templateNumber = cachedTemplates.filter(
      (t) => t.baseTemplateName === rootTemplateName
    ).length + 1;

    return `${rootTemplateName} (${templateNumber})`;
  }


  getCachedTemplates() {
    return this.templateCacheService.getCachedTemplates();
  }
}
